module.exports = __webpack_public_path__ + "img/logo-ress2.2812e0b6.png";